import { PlusCircleOutlined, ProfileOutlined } from "@ant-design/icons";
import { Button } from "antd";
import { makeAutoObservable } from "mobx";
import { observer } from "mobx-react-lite";
import * as React from "react";
import { Link } from "react-router-dom";
import {
  columnDisplayId,
  sysColumnsHistory,
} from "src/business/sysData/sysColumns";
import { valueCatalogsLoader } from "src/business/valueCatalog/apiValueCatalog";
import { ValueCatalogFilter } from "src/business/valueCatalog/ValueCatalogFilter";
import { ZValueCatalog } from "src/business/valueCatalog/ZValueCatalog";
import { BlankLink } from "src/components/BlankLink";
import {
  makeMdmActionColumn,
  MdmTable,
  RenderLinkAction,
} from "src/components/MdmTable";
import { RtColumnsSettingsButton } from "src/components/ReactiveTable/components/RtColumnsSettings";
import { RtColumn } from "src/components/ReactiveTable/RtColumn";
import { RtStore } from "src/components/ReactiveTable/RtStore";
import { ToolBox2 } from "src/components/ToolBox2";
import { makeUrl } from "src/routes/makeUrl";
import { PageUrl } from "src/routes/PageUrl";

import { ObjectsManager } from "../ObjectsManager";

export const ManagementValueCatalog: React.FC = observer(() => {
  const tools = (
    <>
      <RtColumnsSettingsButton store={pageStore.tableStore} />
      <Link to={makeUrl(PageUrl.managementValueCatalogNew)}>
        <Button type="primary" icon={<PlusCircleOutlined />}>
          Создать
        </Button>
      </Link>
    </>
  );

  return (
    <ObjectsManager tab="valueCatalogs">
      <ToolBox2 extraTools={tools} paddingMode="page">
        <MdmTable
          store={pageStore.tableStore}
          columns={columns}
          resizableColumns
          rowClick={{
            type: "link",
            builder: (row) =>
              makeUrl(PageUrl.managementValueCatalogEdit, { id: row.id }),
          }}
        />
      </ToolBox2>
    </ObjectsManager>
  );
});

const pageStore = makeAutoObservable({
  tableStore: new RtStore<ZValueCatalog, ValueCatalogFilter>({
    rowKey: "id",
    loader: valueCatalogsLoader(),
  }),
});

const columns: RtColumn<ZValueCatalog>[] = [
  columnDisplayId,
  {
    key: "name",
    title: "Название",
    render: (row) => row.name,
    minWidth: 100,
    width: 200,
  },
  {
    key: "description",
    title: "Описание",
    render: (row) => row.description,
    minWidth: 100,
  },
  {
    key: "scheme",
    title: "Спецификация",
    render: ({ schema }) => (
      <BlankLink
        href={makeUrl(PageUrl.managementValueSpecCard, { id: schema.id })}
        title="Открыть карточку спецификации в новой вкладке"
      >
        {schema.label}
      </BlankLink>
    ),
    minWidth: 100,
    width: 200,
  },
  ...sysColumnsHistory,
  makeMdmActionColumn<ZValueCatalog>({
    key: "records",
    render: ({ id }) => (
      <RenderLinkAction
        icon={<ProfileOutlined />}
        tooltip="Открыть список в новой вкладке"
        href={makeUrl(PageUrl.valueCatalog, { id })}
      />
    ),
  }),
];
